// Generated by purs version 0.13.8
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Types_Generic_Rep = require("../Data.Argonaut.Types.Generic.Rep/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Partial_Unsafe = require("../Partial.Unsafe/index.js");
var DecodeRepArgs = function (decodeRepArgs) {
    this.decodeRepArgs = decodeRepArgs;
};
var DecodeRep = function (decodeRepWith) {
    this.decodeRepWith = decodeRepWith;
};
var DecodeLiteral = function (decodeLiteral) {
    this.decodeLiteral = decodeLiteral;
};
var withTag = function (e) {
    return function (j) {
        return function (name) {
            var decodingErr = function (msg) {
                return "When decoding a " + (name + (": " + msg));
            };
            return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr("expected an object"))(Data_Argonaut_Core.toObject(j)))(function (jObj) {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr("'" + (e.tagKey + "' property is missing")))(Foreign_Object.lookup(e.tagKey)(jObj)))(function (jTag) {
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr("'" + (e.tagKey + "' property is not a string")))(Data_Argonaut_Core.toString(jTag)))(function (tag) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither)(Control_Applicative.when(Data_Either.applicativeEither)(tag !== name)(Data_Either.Left.create(decodingErr("'" + (e.tagKey + "' property has an incorrect value")))))(function () {
                            return Control_Applicative.pure(Data_Either.applicativeEither)({
                                tag: tag,
                                decodingErr: decodingErr
                            });
                        });
                    });
                });
            });
        };
    };
};
var withTagAndValues = function (e) {
    return function (j) {
        return function (name) {
            return Control_Bind.bind(Data_Either.bindEither)(withTag(e)(j)(name))(function (v) {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr("expected an object"))(Data_Argonaut_Core.toObject(j)))(function (jObj) {
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr("'" + (e.valuesKey + "' property is missing")))(Foreign_Object.lookup(e.valuesKey)(jObj)))(function (values) {
                        return Control_Applicative.pure(Data_Either.applicativeEither)({
                            tag: v.tag,
                            values: values,
                            decodingErr: v.decodingErr
                        });
                    });
                });
            });
        };
    };
};
var decodeRepWith = function (dict) {
    return dict.decodeRepWith;
};
var genericDecodeJsonWith = function (dictGeneric) {
    return function (dictDecodeRep) {
        return function (e) {
            var $63 = Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.to(dictGeneric));
            var $64 = decodeRepWith(dictDecodeRep)(e);
            return function ($65) {
                return $63($64($65));
            };
        };
    };
};
var genericDecodeJson = function (dictGeneric) {
    return function (dictDecodeRep) {
        return genericDecodeJsonWith(dictGeneric)(dictDecodeRep)(Data_Argonaut_Types_Generic_Rep.defaultEncoding);
    };
};
var decodeRepSum = function (dictDecodeRep) {
    return function (dictDecodeRep1) {
        return new DecodeRep(function (e) {
            return function (j) {
                return Control_Alt.alt(Data_Either.altEither)(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inl.create)(decodeRepWith(dictDecodeRep)(e)(j)))(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inr.create)(decodeRepWith(dictDecodeRep1)(e)(j)));
            };
        });
    };
};
var decodeRepNoConstructors = new DecodeRep(function (e) {
    return function (v) {
        return new Data_Either.Left("Cannot decode empty data type");
    };
});
var decodeRepArgsNoArguments = new DecodeRepArgs(function (js) {
    return new Data_Either.Right({
        init: Data_Generic_Rep.NoArguments.value,
        rest: js
    });
});
var decodeRepArgsArgument = function (dictDecodeJson) {
    return new DecodeRepArgs(function (js) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note("too few values were present")(Data_Array.uncons(js)))(function (v) {
            return Data_Functor.map(Data_Either.functorEither)(function ($66) {
                return (function (v1) {
                    return {
                        init: v1,
                        rest: v.tail
                    };
                })(Data_Generic_Rep.Argument($66));
            })(Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson)(v.head));
        });
    });
};
var decodeRepArgs = function (dict) {
    return dict.decodeRepArgs;
};
var decodeRepArgsProduct = function (dictDecodeRepArgs) {
    return function (dictDecodeRepArgs1) {
        return new DecodeRepArgs(function (js) {
            return Control_Bind.bind(Data_Either.bindEither)(decodeRepArgs(dictDecodeRepArgs)(js))(function (v) {
                return Control_Bind.bind(Data_Either.bindEither)(decodeRepArgs(dictDecodeRepArgs1)(v.rest))(function (v1) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)({
                        init: new Data_Generic_Rep.Product(v.init, v1.init),
                        rest: v1.rest
                    });
                });
            });
        });
    };
};
var decodeRep = function (dictDecodeRep) {
    return decodeRepWith(dictDecodeRep)(Data_Argonaut_Types_Generic_Rep.defaultEncoding);
};
var decodeLiteralConstructorCannotTakeProduct = function (dictFail) {
    return new DecodeLiteral(function (v) {
        return function (v1) {
            return Partial_Unsafe.unsafeCrashWith("unreachable DecodeLiteral was reached.");
        };
    });
};
var decodeLiteralConstructor = function (dictIsSymbol) {
    return new DecodeLiteral(function (tagNameTransform) {
        return function (j) {
            var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
            var decodingErr = function (msg) {
                return "When decoding a " + (name + (": " + msg));
            };
            return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(decodingErr("could not read string for constructor"))(Data_Argonaut_Core.toString(j)))(function (tag) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither)(Control_Applicative.when(Data_Either.applicativeEither)(tag !== tagNameTransform(name))(Data_Either.Left.create(decodingErr("string literal ") + (tag + " had an incorrect value."))))(function () {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(Data_Generic_Rep.NoArguments.value);
                });
            });
        };
    });
};
var decodeLiteral = function (dict) {
    return dict.decodeLiteral;
};
var decodeLiteralSumInst = function (dictDecodeLiteral) {
    return function (dictDecodeLiteral1) {
        return new DecodeLiteral(function (tagNameTransform) {
            return function (j) {
                return Control_Alt.alt(Data_Either.altEither)(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inl.create)(decodeLiteral(dictDecodeLiteral)(tagNameTransform)(j)))(Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.Inr.create)(decodeLiteral(dictDecodeLiteral1)(tagNameTransform)(j)));
            };
        });
    };
};
var decodeLiteralSumWithTransform = function (dictGeneric) {
    return function (dictDecodeLiteral) {
        return function (tagNameTransform) {
            var $67 = Data_Functor.map(Data_Either.functorEither)(Data_Generic_Rep.to(dictGeneric));
            var $68 = decodeLiteral(dictDecodeLiteral)(tagNameTransform);
            return function ($69) {
                return $67($68($69));
            };
        };
    };
};
var decodeLiteralSum = function (dictGeneric) {
    return function (dictDecodeLiteral) {
        return decodeLiteralSumWithTransform(dictGeneric)(dictDecodeLiteral)(Control_Category.identity(Control_Category.categoryFn));
    };
};
var construct = function (dictDecodeRepArgs) {
    return function (e) {
        return function (valuesArray) {
            return function (decodingErr) {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Bifunctor.lmap(Data_Either.bifunctorEither)(decodingErr)(decodeRepArgs(dictDecodeRepArgs)(valuesArray)))(function (v) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither)(Control_Applicative.when(Data_Either.applicativeEither)(Data_Eq.notEq(Data_Eq.eqArray(Data_Argonaut_Core.eqJson))(v.rest)([  ]))(Data_Either.Left.create(decodingErr("'" + (e.valuesKey + "' property had too many values")))))(function () {
                        return Control_Applicative.pure(Data_Either.applicativeEither)(v.init);
                    });
                });
            };
        };
    };
};
var decodeRepConstructor = function (dictIsSymbol) {
    return function (dictDecodeRepArgs) {
        return new DecodeRep(function (e) {
            return function (j) {
                var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                return Control_Bind.bind(Data_Either.bindEither)(withTagAndValues(e)(j)(name))(function (v) {
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr("'" + (e.valuesKey + "' property is not an array")))(Data_Argonaut_Core.toArray(v.values)))(function (valuesArray) {
                        return construct(dictDecodeRepArgs)(e)(valuesArray)(v.decodingErr);
                    });
                });
            };
        });
    };
};
var decodeRepConstructorArg = function (dictIsSymbol) {
    return function (dictDecodeJson) {
        return new DecodeRep(function (e) {
            return function (j) {
                var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                return Control_Bind.bind(Data_Either.bindEither)(withTagAndValues(e)(j)(name))(function (v) {
                    if (e.unwrapSingleArguments) {
                        return construct(decodeRepArgsArgument(dictDecodeJson))(e)([ v.values ])(v.decodingErr);
                    };
                    return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note(v.decodingErr("'" + (e.valuesKey + "' property is not an array")))(Data_Argonaut_Core.toArray(v.values)))(function (valuesArray) {
                        return construct(decodeRepArgsArgument(dictDecodeJson))(e)(valuesArray)(v.decodingErr);
                    });
                });
            };
        });
    };
};
var decodeRepConstructorNoArgs = function (dictIsSymbol) {
    return new DecodeRep(function (e) {
        return function (j) {
            var name = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
            return Control_Bind.bind(Data_Either.bindEither)(withTag(e)(j)(name))(function (v) {
                return construct(decodeRepArgsNoArguments)(e)([  ])(v.decodingErr);
            });
        };
    });
};
module.exports = {
    DecodeRep: DecodeRep,
    DecodeRepArgs: DecodeRepArgs,
    DecodeLiteral: DecodeLiteral,
    decodeRep: decodeRep,
    decodeRepWith: decodeRepWith,
    decodeRepArgs: decodeRepArgs,
    genericDecodeJson: genericDecodeJson,
    genericDecodeJsonWith: genericDecodeJsonWith,
    decodeLiteralSum: decodeLiteralSum,
    decodeLiteralSumWithTransform: decodeLiteralSumWithTransform,
    decodeLiteral: decodeLiteral,
    decodeRepNoConstructors: decodeRepNoConstructors,
    decodeRepSum: decodeRepSum,
    decodeRepConstructorNoArgs: decodeRepConstructorNoArgs,
    decodeRepConstructorArg: decodeRepConstructorArg,
    decodeRepConstructor: decodeRepConstructor,
    decodeRepArgsNoArguments: decodeRepArgsNoArguments,
    decodeRepArgsProduct: decodeRepArgsProduct,
    decodeRepArgsArgument: decodeRepArgsArgument,
    decodeLiteralSumInst: decodeLiteralSumInst,
    decodeLiteralConstructor: decodeLiteralConstructor,
    decodeLiteralConstructorCannotTakeProduct: decodeLiteralConstructorCannotTakeProduct
};
